var map = {
	"./articles/data-classification.md": 4363,
	"./company-logo-1.png": 6933,
	"./company-logo-2.png": 6574,
	"./company-logo-3.png": 2151,
	"./company-logo-4.png": 3160,
	"./company-logo-5.png": 4289,
	"./company-logo-6.png": 58,
	"./company-logo-7.png": 8915,
	"./company-logo-8.png": 3620,
	"./csv_ocr_case.jpeg": 1985,
	"./industrial_jose.jpeg": 620,
	"./intemic.png": 5739,
	"./landingph.png": 1379,
	"./logo.svg": 3935,
	"./logo_main.png": 2869,
	"./ocr_case.jpeg": 3788,
	"./reportally.png": 9088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;